// extracted by mini-css-extract-plugin
export var closeButton = "_g-1";
export var container = "_g-0";
export var fullModalImage = "_g-2";